var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilledBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.479 12.769 9.053 18.342a5 5 0 0 0 3.761 2.733l20.242 2.941a5 5 0 0 1 2.765 8.521L75.656 59.583a5 5 0 0 0-1.436 4.422l3.458 20.16a5 5 0 0 1-7.248 5.266l-18.106-9.518a4.988 4.988 0 0 0-4.648 0L29.57 89.431a5 5 0 0 1-7.248-5.266l3.458-20.16a5 5 0 0 0-1.436-4.422L9.7 45.306a5 5 0 0 1 2.769-8.521l20.242-2.941a5 5 0 0 0 3.761-2.733l9.053-18.342a4.994 4.994 0 0 1 8.954 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilledBig);
export default __webpack_public_path__ + "static/media/star-filled-big.c96e5b79a6fb4cc5bcb2c4fead48a04b.svg";
export { ForwardRef as ReactComponent };